import { ProductCardProps } from '../../types';
import { twMerge } from 'tailwind-merge';
import { CroppedImage } from '@weee-fe/module';
import { isMobileBrowser } from '@/utils/tool';
import { getImgUrl } from '@/utils/productFormat';

const CardHeadImage: React.FC<Partial<
  ProductCardProps & {
    imageNode?: React.ReactNode | (() => React.ReactNode);
  }
>> = props => {
  const { data, imageNode, imageSize, className, imageProps = {} } = props;
  const { placeholderClassName, boxClassName, ...rest } = imageProps;
  const isPc = !isMobileBrowser();
  const productImage = (
    <>
      <CroppedImage
        data-testid="wid-product-card-product-image"
        className={twMerge('w-full h-full absolute top-0 left-0 m-0 object-cover rounded-400 aspect-square', className)}
        data-role="product-image"
        alt={`weee_${data?.parent_category}_${data?.name}`}
        url={getImgUrl(data)}
        configs={{
          renderWidth: imageSize || (isPc ? 350 : 170)
        }}
        wrapperClassName="absolute top-0 left-0 right-0 bottom-0 w-full aspect-square"
        placeholder={
          <div
            className={twMerge(
              'w-full h-full absolute top-0 left-0 m-0 object-cover skeleton bg-surface-200-bg',
              placeholderClassName || ''
            )}>
            <div className="w-full h-full default-img" />
          </div>
        }
        {...rest}
      />
      {!!boxClassName && (
        <div className={twMerge('absolute left-0 right-0 top-0 bottom-0 bg-product-bg-img-tint', boxClassName || '')} />
      )}
    </>
  );

  if (props.isRobot) {
    return productImage;
  }
  if (imageNode) {
    const _imageNode = typeof imageNode === 'function' ? imageNode() : imageNode;
    if (_imageNode) {
      return _imageNode;
    }
  }
  return productImage;
};

export default CardHeadImage;
